import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function CrossIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="24"
        height="24"
        viewBox="4 4 16 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.7 7.3C16.3 6.9 15.7 6.9 15.3 7.3L12 10.6L8.7 7.3C8.3 6.9 7.7 6.9 7.3 7.3C6.9 7.7 6.9 8.3 7.3 8.7L10.6 12L7.3 15.3C6.9 15.7 6.9 16.3 7.3 16.7C7.5 16.9 7.7 17 8 17C8.3 17 8.5 16.9 8.7 16.7L12 13.4L15.3 16.7C15.5 16.9 15.8 17 16 17C16.2 17 16.5 16.9 16.7 16.7C17.1 16.3 17.1 15.7 16.7 15.3L13.4 12L16.7 8.7C17.1 8.3 17.1 7.7 16.7 7.3Z"
        />
      </svg>
    </Icon>
  );
}
